import React from 'react';
import { createContext } from 'react';
import PropTypes from 'prop-types';

export const WizardContext = createContext(null);

export function WizardProvider({
  GTicketList,
  children,
  handleNextStep,
  handlePrevStep,
  isLastPage,
  modalRefundNotApplicableValidations,
  nonRefundableExtrasExist,
  penaltyChargeCard,
  quotationsToRender,
  setPenaltyChargeCard,
  setCancelRefundModal,
  setSpecialRefundModal,
  step,
  thereAreDTickets,
}) {
  return (
    <WizardContext.Provider value={{
      GTicketList,
      handleNextStep,
      handlePrevStep,
      isLastPage,
      modalRefundNotApplicableValidations,
      nonRefundableExtrasExist,
      penaltyChargeCard,
      quotationsToRender,
      setPenaltyChargeCard,
      setCancelRefundModal,
      setSpecialRefundModal,
      step,
      thereAreDTickets,
    }}>
      { children }
    </WizardContext.Provider>
  );
}

WizardProvider.propTypes = {
  children: PropTypes.element,
  handleNextStep: PropTypes.func,
  handlePrevStep: PropTypes.func,
  isLastPage: PropTypes.bool,
  modalRefundNotApplicableValidations: PropTypes.object,
  setCancelRefundModal: PropTypes.func,
  setSpecialRefundModal: PropTypes.func,
  step: PropTypes.number,
};